package com.evoapps.evoshift.domain.model

/**
 * SH-117: what the month's working time is handed to the accountant as (functions/accountantExport.js,
 * docs/exports.md). EVoShift never calculates the pay: the accountant's payroll software does.
 */
enum class AccountantExportFormat {
    /** Ewidencja czasu pracy: one page per person (Kodeks pracy art. 149). */
    TIME_RECORD_PDF,
    /** The same record as a workbook: summary, every day, attendance grid. */
    TIME_RECORD_XLSX,
    /** Lista obecności: people down, days across. */
    ATTENDANCE_PDF,
    /** EVoShift's own specified CSV, one row per person and day, for mapping in any program. */
    GENERIC_CSV,
    /** Comarch ERP Optima: RCP punches in a text format the accountant defines once. */
    OPTIMA_RCP,
    /** Symfonia Kadry i Płace: the standard RCP format "SYMFONIA". */
    SYMFONIA_RCP,
    /** enova365: RCP punches for a reader defined once. */
    ENOVA_RCP,
    /** All of the above in one ZIP with a README. */
    PACKAGE;

    /** The RCP files match people by their payroll ID (the RCP card number); others are left out. */
    val needsPayrollIds: Boolean get() = this == OPTIMA_RCP || this == SYMFONIA_RCP || this == ENOVA_RCP || this == PACKAGE
}

/** The export made: the file behind a 24-hour link, and what the person should know about it. */
data class AccountantExport(
    val url: String,
    /** ISO-8601 instant the link stops working. */
    val expiresAt: String,
    val fileName: String,
    val sizeBytes: Long,
    /** How many people the month lists. */
    val people: Int,
    /** People with hours but no usable payroll ID: left out of the RCP files. */
    val withoutPayrollId: List<String>,
    /** The accountant's address when it was e-mailed, else null. */
    val emailedTo: String? = null,
    /** The file was attached to the e-mail (larger ones go by link only). */
    val attached: Boolean = false
)

/** An export was e-mailed less than a minute ago (one e-mail per workplace per minute). */
class AccountantMailLimitException : Exception("An export was just e-mailed. Please wait a minute.")

/** E-mail is not set up on the server (no SendGrid template): only downloads work. */
class AccountantMailUnavailableException : Exception("E-mail is not set up.")

/** The accountant's address is not an e-mail address. */
class InvalidEmailException : IllegalArgumentException("The e-mail address is invalid.")
